<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-container">
        <div class="scroll_md">
          <slot name="scrollDown"></slot>
        </div>
        <div class="modal-header">
          <slot name="header"></slot>
        </div>

        <div class="modal-body">
          <div class="container d-flex justify-content-center text-black">
            <TermConditions />
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-default-button" @click="$emit('close')">
              OK
            </button>
          </slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import TermConditions from "../global/TermConditions.vue";
export default {
  props: {
    show: Boolean,
  },
  components: {
    TermConditions,
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 1200px;
  height: 95%;
  margin: auto;
  padding: 20px 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  position: relative;
  margin: 20px 0;
  height: 78%;
  overflow-y: scroll;
  /* margin: 0 40px; */
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.scroll_md {
  position: absolute;
  right: 10%;
  z-index: 999;
}

@media (max-width: 900px) {
  .modal-container {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 500px) {
  .modal-container {
    width: 100%;
  }

  .modal-body {
    padding: 0;
  }
}
</style>
